// extracted by mini-css-extract-plugin
export default {"btn":"LightButton_btn__hCnqm"};